import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";
import LiveCourseParticipant from "@/models/LiveCourseParticipant";

export default class BuyCourse {
    constructor(raw = {}) {
        this.id = raw.id;
        this.title = raw.title;
        this.description = raw.description;
        this.canBorrowBooks = raw.canBorrowBooks;
        this.lastAssessmentDateRequired = raw.lastAssessmentDateRequired;
        this.tags = raw.tags;
        this.tagKey = raw.tagKey;
        this.price = raw.price;
        this.online = raw.online;
        this.location = raw.location;
        this.applicantsWaiting = raw.applicantsWaiting;
    }
}
